// src/components/OtpInputs.jsx
import React, { useEffect, useRef } from "react";

export default function OtpInputs({ value = "", onChange, length = 6, disabled }) {
  const boxes = Array.from({ length });
  const refs = useRef([]);

  useEffect(() => { refs.current[0]?.focus(); }, []);

  const setAt = (i, v) => {
    const digits = (value || "").split("");
    digits[i] = v.replace(/\D/g, "").slice(-1) || "";
    const next = digits.join("").slice(0, length);
    onChange?.(next);
    // jump
    if (v && i < length - 1) refs.current[i + 1]?.focus();
  };

  const onKeyDown = (i, e) => {
    if (e.key === "Backspace" && !value[i] && i > 0) refs.current[i - 1]?.focus();
    if (e.key === "ArrowLeft" && i > 0) refs.current[i - 1]?.focus();
    if (e.key === "ArrowRight" && i < length - 1) refs.current[i + 1]?.focus();
  };

  return (
    <div className="flex gap-2">
      {boxes.map((_, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          inputMode="numeric"
          pattern="\d*"
          maxLength={1}
          disabled={disabled}
          value={(value || "")[i] || ""}
          onChange={(e) => setAt(i, e.target.value)}
          onKeyDown={(e) => onKeyDown(i, e)}
          className="h-12 w-10 text-center rounded-lg border text-lg font-semibold outline-none focus:ring-2 focus:ring-amber-300"
        />
      ))}
    </div>
  );
}
